<template>
  <div class="header-company-rating">
    <i class="fa-solid fa-star header-company-rating__star" />
    <span class="header-company-rating__score">
      {{ modelValue !== null ? modelValue : "–" }}
    </span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: number | null;
}>();
</script>

<style lang="postcss">
.header-company-rating {
  @apply flex items-center gap-0.5;

  &__star {
    @apply text-xs text-warning-300;
  }

  &__score {
    @apply text-sm font-semibold text-gray-900;
  }
}
</style>
